// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CookieConsent from "react-cookie-consent";

export default function CookieInfo() {
    const { t } = useTranslation('translation', { keyPrefix: 'cookieinfo' });

    return (
        <CookieConsent
            location="bottom"
            containerClasses="cookie-bar"
            buttonText={t('cookieconsentbutton')}
            cookieName="teensthingsCookieConsent"
            style={{ background: "var(--bs-gray-700)", textAlign: 'center', zIndex: '9999' }}
            buttonStyle={{ color: "var((--bs-gray-700)", fontSize: "13px" }}
            expires={150}
        >
            <Trans t={t}>cookieconsent</Trans>
        </CookieConsent>
    );
}
